import React from 'react';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

export const AccountantButtons = ({ accountingSettlement, activeClients, handleOpenConfirmDialog, handleClose }) => {
    return (
        <>
            {accountingSettlement?.statementFinished && !accountingSettlement?.isDeclarationSent && (
                <MenuItem onClick={() => { handleClose(); handleOpenConfirmDialog("Zakończ i wyślij zestawienie", "Czy potwierdzasz, że chcesz zakończyć i wysłać zestawienie?", "sendDeclaration", false); }}>
                    <ListItemIcon><i className="fas fa-file-upload" style={{ color: '#3b82f6', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Wgraj fakturę" />
                </MenuItem>
            )}
            {!(accountingSettlement?.statementFinished || activeClients == 0) && (
                <MenuItem onClick={() => { handleClose(); handleOpenConfirmDialog("Zakończ i wyślij zestawienie", "Czy potwierdzasz, że chcesz zakończyć i wysłać zestawienie?", "saveAndSend", false); }}>
                    <ListItemIcon><i className="fas fa-paper-plane" style={{ color: '#10b981', fontSize: '1.2rem' }}></i></ListItemIcon>
                    <ListItemText primary="Zakończ i wyślij" />
                </MenuItem>
            )}
        </>
    );
};